<div
  class="controlchat-fab"
  *ngIf="canView && userId && !embedded"
  [class.has-unread]="hasUnreadMessages"
  (click)="toggleOpen()"
>
  <mat-icon>{{ isOpen ? 'close' : 'chat' }}</mat-icon>
</div>

<div class="controlchat-backdrop" *ngIf="isOpen && !embedded" (click)="closePanel()"></div>

<aside class="controlchat-panel" *ngIf="isOpen" [class.embedded]="embedded">
  <header class="panel-header" *ngIf="!embedded">
    <div class="panel-title">
      <h3>ControlChat</h3>
      <span class="version-badge">v2 Plus</span>
      <button type="button" class="icon" (click)="toggleHeaderMenu()" title="Menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    <div class="panel-user">
      <div class="user-avatar header-user-avatar" [class.has-photo]="getUserAvatarUrl(currentUser)">
        <ng-container *ngIf="getUserAvatarUrl(currentUser) as avatarUrl; else headerUserInitial">
          <img [src]="avatarUrl" [alt]="'Foto de ' + (currentUser?.name || 'Usuário')">
        </ng-container>
        <ng-template #headerUserInitial>
          {{ (currentUser?.name || 'U').charAt(0).toUpperCase() }}
        </ng-template>
      </div>
      <div class="panel-user-info">
        <strong class="truncate">{{ formatUserName(currentUser?.name) }}</strong>
        <small class="truncate">{{ currentUser?.email }}</small>
      </div>
      <button *ngIf="!embedded" type="button" class="icon" (click)="closePanel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <div class="panel-menu" *ngIf="isHeaderMenuOpen">
      <div class="panel-menu-header">
        <button type="button" class="icon-button" (click)="headerMenuView === 'root' ? closeHeaderMenu() : backHeaderMenu()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span *ngIf="headerMenuView === 'root'">Menu</span>
        <span *ngIf="headerMenuView === 'create-group'">Novo grupo</span>
        <span *ngIf="headerMenuView === 'keywords'">Gerenciar palavras</span>
      </div>
      <div class="panel-menu-actions" *ngIf="headerMenuView === 'root'">
        <button type="button" class="menu-action" *ngIf="!isRestrictedProfile && canCreate" (click)="openCreateGroupFromMenu()">
          Criar grupo
        </button>
        <button type="button" class="menu-action" *ngIf="!isRestrictedProfile && canManage" (click)="openKeywordsFromMenu()">
          Gerenciar palavras
        </button>
        <button type="button" class="menu-action" *ngIf="embedded" (click)="logoutDesktop()">
          Sair
        </button>
        <div class="menu-toggle" *ngIf="!embedded">
          <mat-slide-toggle [(ngModel)]="soundEnabled" (change)="onSoundToggle($event.checked)">
            Aviso sonoro
          </mat-slide-toggle>
        </div>
      </div>
      <div class="panel-menu-content" *ngIf="headerMenuView === 'create-group'">
        <div class="group-form" *ngIf="isCreatingGroup" #groupForm>
          <input
            type="text"
            placeholder="Nome do grupo"
            [(ngModel)]="groupName"
          >
          <div class="group-member-search">
            <mat-icon>person_add</mat-icon>
            <input
              type="text"
              placeholder="Adicionar integrante"
              [(ngModel)]="groupMemberQuery"
              (input)="onGroupMemberSearch()"
            >
          </div>
          <div class="member-results" *ngIf="groupMemberResults.length">
            <button
              type="button"
              class="member-row"
              *ngFor="let user of groupMemberResults"
              (click)="addGroupMember(user)"
            >
              <span class="status-dot" [class.online]="user.online" [class.offline]="!user.online"></span>
              <div class="user-avatar" [class.has-photo]="getUserAvatarUrl(user)">
                <ng-container *ngIf="getUserAvatarUrl(user) as avatarUrl; else groupMemberInitialMenu">
                  <img [src]="avatarUrl" [alt]="'Foto de ' + (user.name || 'Usuário')">
                </ng-container>
                <ng-template #groupMemberInitialMenu>
                  {{ (user.name || 'U').charAt(0).toUpperCase() }}
                </ng-template>
              </div>
              <div class="user-info">
                <strong>{{ formatUserName(user.name) }}</strong>
                <small>{{ user.email }}</small>
              </div>
            </button>
          </div>
          <div class="member-selected" *ngIf="groupMembers.length">
            <div class="member-chip" *ngFor="let member of groupMembers">
              <span>{{ formatUserName(member.name) }}</span>
              <button type="button" (click)="removeDraftGroupMember(member)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <button
            type="button"
            class="group-submit"
            (click)="submitGroup()"
            [disabled]="!groupName.trim() || groupMembers.length === 0"
          >Criar grupo</button>
        </div>
      </div>
      <div class="panel-menu-content" *ngIf="headerMenuView === 'keywords'">
        <div class="section" *ngIf="canManage" #monitoringSection>
          <div class="section-header">
            <span>Monitoramento</span>
          </div>
          <div class="keyword-input">
            <input type="text" placeholder="Adicionar palavra-chave" [(ngModel)]="keywordInput">
            <button type="button" (click)="addKeyword()">Adicionar</button>
          </div>
          <div class="keyword-list">
            <div class="keyword-row" *ngFor="let keyword of keywords">
              <span>{{ keyword.phrase }}</span>
              <button type="button" (click)="removeKeyword(keyword.id)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div class="monitoring-list">
            <div class="monitoring-item" *ngFor="let hit of monitoringHits">
              <strong>{{ hit.keyword_phrase }}</strong>
              <small>{{ hit.user_name }} · {{ hit.created_at | date:'short' }}</small>
              <span>{{ hit.message_text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-left">
    <div class="search-box">
      <mat-icon>search</mat-icon>
      <input type="text" placeholder="Pesquisar usuários" [(ngModel)]="searchTerm" (input)="onSearchChange()">
      <button type="button" class="search-menu" *ngIf="embedded" (click)="toggleHeaderMenu()" title="Menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <button type="button" class="search-clear" *ngIf="searchTerm.trim().length" (click)="clearSearch()" title="Limpar">
        <mat-icon>close</mat-icon>
      </button>
    </div>

      <div class="section user-section">
        <div class="user-list" *ngIf="searchTerm.trim().length">
          <div class="user-row" *ngFor="let user of users" (click)="selectUser(user)">
            <div class="user-row-main">
              <span class="status-dot" [class.online]="user.online" [class.offline]="!user.online"></span>
              <div class="user-avatar" [class.has-photo]="getUserAvatarUrl(user)">
                <ng-container *ngIf="getUserAvatarUrl(user) as avatarUrl; else userInitial">
                  <img [src]="avatarUrl" [alt]="'Foto de ' + (user.name || 'Usuário')">
                </ng-container>
                <ng-template #userInitial>
                  {{ (user.name || 'U').charAt(0).toUpperCase() }}
                </ng-template>
              </div>
              <div class="user-info">
                <strong class="truncate">{{ formatUserName(user.name) }}</strong>
                <small class="truncate">{{ user.email }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" *ngIf="assistants.length || loadingAssistants">
        <div class="section-header">
          <span>Assistentes virtuais</span>
        </div>
        <div class="chat-list limited assistants-list">
          <div class="chat-row assistant-row" *ngFor="let assistant of assistants" [class.active]="isAssistantSelected(assistant)" (click)="openAssistantConversation(assistant)">
            <div class="chat-row-main">
              <span class="status-dot online"></span>
              <div class="user-avatar chat-avatar assistant-avatar">
                <mat-icon>smart_toy</mat-icon>
              </div>
              <div class="chat-row-info">
                <strong class="truncate">{{ assistant.title }}</strong>
                <small class="chat-preview truncate">{{ getAssistantPreview(assistant) }}</small>
              </div>
            </div>
            <div class="chat-row-time">
              {{ formatConversationTime(assistant.last_activity_at) }}
            </div>
          </div>
          <small *ngIf="loadingAssistants">Carregando assistentes...</small>
        </div>
      </div>

      <div class="section conversations-section">
        <div class="section-header">
          <span>Conversas</span>
        </div>
        <div class="chat-list limited">
          <ng-container *ngFor="let conv of conversations">
            <div
              class="chat-row"
              [class.unread]="isConversationUnread(conv.id)"
              [class.last-incoming]="conv.id === lastIncomingConversationId"
              [class.active]="selectedConversation?.id === conv.id"
              (click)="openConversation(conv)"
            >
              <div class="chat-row-main">
                <span
                  class="status-dot"
                  [class.online]="conv.type === 'DIRECT' && isUserOnline(conv.other_user_id)"
                  [class.offline]="conv.type === 'DIRECT' && !isUserOnline(conv.other_user_id)"
                ></span>
                <div
                  class="user-avatar chat-avatar"
                  [class.group-avatar]="conv.type === 'GROUP'"
                  [class.has-photo]="conv.type === 'DIRECT' && getConversationAvatarUrl(conv)"
                >
                  <ng-container *ngIf="conv.type === 'DIRECT' && getConversationAvatarUrl(conv) as avatarUrl; else chatInitialUnified">
                    <img [src]="avatarUrl" [alt]="'Foto de ' + (conv.other_user_name || 'Usuário')">
                  </ng-container>
                  <ng-template #chatInitialUnified>
                    {{
                      (conv.type === 'GROUP'
                        ? (conv.group_name || 'G')
                        : (conv.other_user_name || 'U')
                      ).charAt(0).toUpperCase()
                    }}
                  </ng-template>
                </div>
                <div class="chat-row-info">
                  <strong class="truncate">
                    {{ conv.type === 'GROUP' ? conv.group_name : conv.other_user_name }}
                  </strong>
                  <small class="chat-preview truncate" *ngIf="getConversationPreview(conv)">
                    {{ getConversationPreview(conv) }}
                  </small>
                </div>
              </div>
              <div class="chat-row-time">
                <span class="mention-badge" *ngIf="isConversationUnread(conv.id) && isConversationMentioned(conv)">&#64;</span>
                {{ formatConversationTime(conv.last_activity_at || conv.last_message_at) }}
              </div>
            </div>
          </ng-container>
        </div>
        <div class="conversation-footer" *ngIf="embedded">
          <button
            type="button"
            class="desktop-refresh-footer-btn"
            (click)="refreshDesktopLayout()"
            [disabled]="reloadingDesktopLayout"
          >
            {{ reloadingDesktopLayout ? 'Atualizando...' : 'Atualizar layout' }}
          </button>
        </div>
      </div>

    </div>

    <div class="panel-right">
      <div class="chat-header" *ngIf="selectedConversation">
        <div class="chat-header-title">
          <span
            class="status-dot"
            *ngIf="selectedConversation.type === 'DIRECT'"
            [class.online]="isUserOnline(selectedConversation.other_user_id)"
            [class.offline]="!isUserOnline(selectedConversation.other_user_id)"
          ></span>
          <div class="user-avatar chat-avatar header-avatar">
            <ng-container *ngIf="selectedConversation.type === 'DIRECT' && getConversationAvatarUrl(selectedConversation) as avatarUrl; else headerInitial">
              <img [src]="avatarUrl" [alt]="'Foto de ' + (selectedConversation.other_user_name || 'Usuário')">
            </ng-container>
            <ng-template #headerInitial>
              {{
                (
                  selectedConversation.type === 'GROUP'
                    ? (selectedConversation.group_name || 'G')
                    : selectedConversation.type === 'AI'
                    ? (selectedConversation.assistant_title || 'A')
                    : (selectedConversation.other_user_name || 'U')
                ).charAt(0).toUpperCase()
              }}
            </ng-template>
          </div>
          <div class="chat-header-text">
            <strong class="truncate">
              {{
                selectedConversation.type === 'GROUP'
                  ? selectedConversation.group_name
                  : selectedConversation.type === 'AI'
                  ? selectedConversation.assistant_title
                  : selectedConversation.other_user_name
              }}
            </strong>
            <small class="truncate" *ngIf="selectedConversation.type === 'DIRECT'">{{ selectedConversation.other_user_email }}</small>
            <small class="chat-subtitle" *ngIf="selectedConversation.type === 'GROUP'">
              {{ selectedConversation.members_count || 0 }} participantes
            </small>
            <small class="chat-subtitle" *ngIf="selectedConversation.type === 'AI'">
              Comando #{{ selectedConversation.assistant_command_id }} · v{{ selectedConversation.assistant_version || 1 }}
            </small>
          </div>
        </div>
        <div class="chat-header-tools">
          <button
            type="button"
            class="icon-button"
            title="Pesquisar na conversa"
            (click)="toggleMessageSearch()"
          >
            <mat-icon>search</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button"
            *ngIf="selectedConversation.type === 'GROUP'"
            title="Configurações do grupo"
            (click)="toggleGroupSettings()"
          >
            <mat-icon>settings</mat-icon>
          </button>
          <div class="chat-header-actions" *ngIf="selectedConversation.type === 'GROUP'">
            <button
              type="button"
              class="icon-button"
              title="Listar integrantes"
            (click)="toggleGroupPanel()"
          >
            <mat-icon>group</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button"
            title="Adicionar integrante"
            (click)="toggleGroupAddMode()"
          >
            <mat-icon>person_add</mat-icon>
          </button>
          <button
            type="button"
            class="icon-button danger"
            title="Excluir grupo"
            *ngIf="canDeleteSelectedGroup()"
            (click)="deleteSelectedGroup()"
          >
            <mat-icon>delete</mat-icon>
          </button>
          </div>
        </div>
      </div>

      <div class="group-settings" *ngIf="selectedConversation?.type === 'GROUP' && showGroupSettings">
        <mat-slide-toggle
          [(ngModel)]="groupOnlyAdmins"
          (change)="onGroupOnlyAdminsChange($event.checked)"
          [disabled]="!isGroupAdminOrOwner()"
        >
          Somente administradores enviam mensagem
        </mat-slide-toggle>
      </div>

      <div class="chat-search" *ngIf="selectedConversation" [class.visible]="showMessageSearch">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Pesquisar na conversa"
          [(ngModel)]="messageSearchTerm"
          (input)="onMessageSearchChange()"
          #messageSearchInput
        >
        <div class="search-meta">
          <span>{{ messageMatchLabel }}</span>
          <button type="button" class="icon-button" [disabled]="!messageMatchCount" (click)="goToPrevMatch()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <button type="button" class="icon-button" [disabled]="!messageMatchCount" (click)="goToNextMatch()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>
      </div>

      <div class="group-member-panel" *ngIf="selectedConversation?.type === 'GROUP' && isGroupPanelOpen">
        <div class="group-member-search">
          <mat-icon>{{ isGroupAddMode ? 'person_add' : 'search' }}</mat-icon>
          <input
            type="text"
            [placeholder]="isGroupAddMode ? 'Buscar integrante para adicionar' : 'Pesquisar integrante do grupo'"
            [(ngModel)]="groupMemberFilter"
            (input)="onGroupMemberFilterChange()"
          >
        </div>
        <div class="member-list" *ngIf="!isGroupAddMode && filteredGroupMembers.length">
          <div class="member-row full" *ngFor="let member of filteredGroupMembers">
            <div class="member-info">
              <span class="member-name">
                {{ formatUserName(member.name) }}{{ isMemberAdmin(member) ? ' (Admin)' : '' }}
              </span>
              <small class="member-email">{{ member.email }}</small>
            </div>
            <div class="member-actions">
              <button
                type="button"
                class="member-role-toggle"
                *ngIf="canToggleMemberRole(member)"
                (click)="toggleMemberAdmin(member)"
              >
                {{ member.role === 'ADMIN' ? 'Remover admin' : 'Tornar admin' }}
              </button>
              <button
                type="button"
                class="member-remove"
                *ngIf="canRemoveMember(member)"
                (click)="removeGroupMember(member)"
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
        <div class="member-results" *ngIf="isGroupAddMode && groupMemberSearchResults.length">
          <button
            type="button"
            class="member-row"
            *ngFor="let user of groupMemberSearchResults"
            (click)="addMemberToSelectedGroup(user)"
          >
            <span class="status-dot" [class.online]="user.online" [class.offline]="!user.online"></span>
            <div class="user-avatar" [class.has-photo]="getUserAvatarUrl(user)">
              <ng-container *ngIf="getUserAvatarUrl(user) as avatarUrl; else groupAddMemberInitial">
                <img [src]="avatarUrl" [alt]="'Foto de ' + (user.name || 'Usuário')">
              </ng-container>
              <ng-template #groupAddMemberInitial>
                {{ (user.name || 'U').charAt(0).toUpperCase() }}
              </ng-template>
            </div>
            <div class="user-info">
              <strong>{{ formatUserName(user.name) }}</strong>
              <small>{{ user.email }}</small>
            </div>
          </button>
        </div>
      </div>

      <div class="chat-empty" *ngIf="!selectedConversation">
        <mat-icon>chat</mat-icon>
        <p>Selecione um assistente virtual, usuário ou conversa para iniciar.</p>
      </div>

      <div class="controlchat-processing-overlay" *ngIf="selectedConversation?.type === 'AI' && sendingAssistantMessage">
        <div class="controlchat-processing-overlay__content">
          <div class="controlchat-processing-overlay__spinner">
            <img src="assets/MIV/brand/versao 1.png" alt="ControlPS">
          </div>
          <strong>{{ assistantLoadingMessage }}</strong>
          <small>Processando sua solicitação no assistente virtual.</small>
        </div>
      </div>

      <div class="chat-messages" *ngIf="selectedConversation" #messagesContainer (click)="closeEmojiPicker()" (scroll)="onMessagesScroll()">
        <div
          class="chat-message-row"
          *ngFor="let msg of filteredMessages; trackBy: trackMessage"
          [class.own]="userId && msg.sender_id === userId"
          [class.match]="isMessageMatch(msg)"
          [class.match-active]="isActiveMessageMatch(msg)"
          [class.actions-open]="reactionPickerMessageId === msg.id"
          [attr.id]="'msg-' + msg.id"
        >
          <div class="message-avatar" *ngIf="userId && msg.sender_id !== userId">
            <ng-container *ngIf="getMessageAvatarUrl(msg) as avatarUrl; else messageInitial">
              <img [src]="avatarUrl" [alt]="'Foto de ' + (msg.sender_name || 'Usuário')">
            </ng-container>
            <ng-template #messageInitial>
              {{ (msg.sender_name || 'U').charAt(0).toUpperCase() }}
            </ng-template>
          </div>
          <div
            class="chat-message"
            [class.own]="userId && msg.sender_id === userId"
          >
            <div class="message-meta">
              <strong>{{ msg.sender_name || 'Usuário' }}</strong>
              <span class="meta-sep">·</span>
              <small>{{ msg.created_at | date:'short' }}</small>
              <span
                class="message-read-dot"
                *ngIf="userId && msg.sender_id === userId"
                [class.seen]="isMessageSeen(msg)"
              ></span>
              <span
                class="message-read-count"
                *ngIf="userId && msg.sender_id === userId && selectedConversation?.type === 'GROUP' && isMessageSeen(msg)"
              >
                {{ getMessageReadCount(msg) }}
              </span>
            </div>
            <div class="reply-preview" *ngIf="msg.reply_to_message_id">
              <small>{{ msg.reply_sender_name || 'Usuário' }}</small>
              <div class="reply-text" [innerHTML]="getReplyPreviewHtml(msg)"></div>
            </div>
            <ng-container *ngIf="!msg.deleted_at">
              <ng-container *ngFor="let attachment of getMessageAttachments(msg); let attachmentIndex = index">
              <button
                type="button"
                class="image-open image-card"
                *ngIf="isImageAttachment(attachment)"
                (click)="openImageModal(attachment.file_path)"
              >
                <img [src]="attachment.file_path" [alt]="attachment.file_name || 'Anexo'">
              </button>
              <ng-container *ngIf="isAudioAttachment(attachment)">
                <ng-container *ngIf="getAudioTrackKey(msg, attachment, attachmentIndex) as audioKey">
                  <div class="audio-player-card">
                    <audio
                      #messageAudioPlayer
                      class="audio-player-native"
                      [src]="attachment.file_path"
                      preload="metadata"
                      (loadedmetadata)="onAudioLoadedMetadata(messageAudioPlayer, audioKey, msg.audio_duration_seconds)"
                      (timeupdate)="onAudioTimeUpdate(messageAudioPlayer, audioKey)"
                      (play)="onAudioPlay(messageAudioPlayer, audioKey)"
                      (pause)="onAudioPause(messageAudioPlayer, audioKey)"
                      (ended)="onAudioEnded(messageAudioPlayer, audioKey)"
                    ></audio>
                    <button
                      type="button"
                      class="audio-play-toggle"
                      (click)="toggleAudioPlayback(messageAudioPlayer, audioKey)"
                    >
                      <mat-icon>{{ isAudioPlaying(audioKey) ? 'pause' : 'play_arrow' }}</mat-icon>
                    </button>
                    <div class="audio-wave" (click)="seekAudioFromWave($event, messageAudioPlayer, audioKey)">
                      <ng-container *ngIf="getAudioWaveBars(audioKey) as waveBars">
                        <span
                          class="audio-wave-bar"
                          *ngFor="let barHeight of waveBars; let barIndex = index"
                          [style.height.px]="barHeight"
                          [class.active]="isAudioWaveBarActive(audioKey, barIndex, waveBars.length)"
                        ></span>
                      </ng-container>
                    </div>
                    <div class="audio-time">
                      <small>{{ getAudioCurrentLabel(audioKey) }}</small>
                      <small>{{ getAudioDurationLabel(audioKey, msg.audio_duration_seconds) }}</small>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <a
                class="file-card"
                *ngIf="attachment.file_path && !isImageAttachment(attachment) && !isAudioAttachment(attachment)"
                [href]="attachment.file_path"
                target="_blank"
              >
                <span class="file-icon">{{ fileExtLabel(attachment.file_name) }}</span>
                <span class="file-meta">
                  <strong class="file-name">{{ truncateFileName(attachment.file_name || 'Arquivo') }}</strong>
                  <small class="file-ext">{{ fileExtLabel(attachment.file_name) }}</small>
                </span>
              </a>
              </ng-container>
            </ng-container>
            <div class="message-body deleted" *ngIf="msg.deleted_at">Mensagem excluída</div>
            <div class="message-body" *ngIf="!msg.deleted_at && msg.message_text" [innerHTML]="getHighlightedMessage(msg)"></div>
            <div
              class="assistant-quick-replies"
              *ngIf="
                !msg.deleted_at &&
                selectedConversation?.type === 'AI' &&
                getMessageQuickReplies(msg).length &&
                isLatestAssistantMessage(msg)
              "
            >
              <button
                type="button"
                class="quick-reply-btn"
                *ngFor="let reply of getMessageQuickReplies(msg)"
                [class.is-disabled]="sendingAssistantMessage"
                (pointerup)="onAssistantQuickReplyClick(reply, $event)"
                (click)="onAssistantQuickReplyClick(reply, $event)"
              >
                {{ reply.label }}
              </button>
            </div>
            <div class="message-reactions" *ngIf="msg.reactions?.length">
              <button
                type="button"
                class="reaction-chip"
                *ngFor="let reaction of msg.reactions"
                [class.reacted]="reaction.reacted"
                (click)="addReaction(msg, reaction.emoji)"
              >
                <span>{{ reaction.emoji }}</span>
                <small>{{ reaction.count }}</small>
              </button>
            </div>
            <div class="message-actions" *ngIf="selectedConversation?.type !== 'AI'">
              <button type="button" class="action-btn reaction-btn" (click)="toggleReactionPicker(msg)" title="Reagir">
                <mat-icon>sentiment_satisfied_alt</mat-icon>
              </button>
              <button type="button" class="action-btn reply-btn" (click)="setReplyTo(msg)" title="Responder">
                <mat-icon>reply</mat-icon>
              </button>
              <button
                type="button"
                class="action-btn delete-btn"
                *ngIf="canDeleteMessage(msg)"
                (click)="deleteMessage(msg)"
                title="Excluir"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <div class="reaction-picker" *ngIf="reactionPickerMessageId === msg.id">
                <button
                  type="button"
                  class="emoji-btn"
                  *ngFor="let emoji of emojiList"
                  (click)="addReaction(msg, emoji)"
                >
                  {{ emoji }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chat-input" *ngIf="selectedConversation">
        <div class="chat-input-locked" *ngIf="isMessageBlocked">
          Somente administradores podem enviar mensagens neste grupo.
        </div>
        <div class="reply-composer" *ngIf="replyToMessage && selectedConversation?.type !== 'AI'">
          <div class="reply-info">
            <strong>{{ replyToMessage.sender_name || 'Usuário' }}</strong>
            <span>{{ replyToMessage.message_text || (replyToMessage.file_name || 'Arquivo') }}</span>
          </div>
          <button type="button" class="reply-close" (click)="clearReply()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div
          class="input-shell"
          [class.has-preview]="pendingFiles.length"
          [class.dragging]="draggingMessage"
          (dragover)="onMessageDragOver($event)"
          (dragleave)="onMessageDragLeave($event)"
          (drop)="onMessageDrop($event)"
        >
          <div class="file-preview" *ngIf="pendingFiles.length">
            <div class="file-preview-media" *ngFor="let item of pendingFiles; let i = index">
              <ng-container *ngIf="isImageFile(item.file)">
                <img [src]="item.previewUrl" alt="Anexo">
              </ng-container>
              <ng-container *ngIf="isAudioFile(item.file)">
                <audio [src]="item.audioPreviewUrl" controls></audio>
              </ng-container>
              <ng-container *ngIf="!isImageFile(item.file) && !isAudioFile(item.file)">
                <div class="file-chip">
                  <mat-icon>attach_file</mat-icon>
                  <span>{{ item.file.name }}</span>
                </div>
              </ng-container>
              <button type="button" class="remove-preview" (click)="clearFile(i)" title="Excluir anexo">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <div class="format-toolbar" *ngIf="!isMessageBlocked" (mousedown)="preserveEditorSelection($event)">
            <button type="button" class="format-btn" (click)="applyFormat('bold')" title="Negrito">
              <mat-icon>format_bold</mat-icon>
            </button>
            <button type="button" class="format-btn" (click)="applyFormat('italic')" title="Itálico">
              <mat-icon>format_italic</mat-icon>
            </button>
            <button type="button" class="format-btn" (click)="applyFormat('underline')" title="Sublinhar">
              <mat-icon>format_underlined</mat-icon>
            </button>
            <button type="button" class="format-btn" (click)="applyFormat('strikeThrough')" title="Tachado">
              <mat-icon>strikethrough_s</mat-icon>
            </button>
            <button type="button" class="format-btn" (click)="applyFormat('insertUnorderedList')" title="Lista com marcadores">
              <mat-icon>format_list_bulleted</mat-icon>
            </button>
            <button type="button" class="format-btn" (click)="applyFormat('insertOrderedList')" title="Lista numerada">
              <mat-icon>format_list_numbered</mat-icon>
            </button>
            <label class="format-color" title="Cor do texto">
              <mat-icon>format_color_text</mat-icon>
              <input type="color" (input)="applyColor('foreColor', $event)">
            </label>
            <label class="format-color" title="Realce do texto">
              <mat-icon>format_color_fill</mat-icon>
              <input type="color" (input)="applyColor('hiliteColor', $event)">
            </label>
            <button type="button" class="format-btn" (click)="applyFormat('removeFormat')" title="Limpar formatação">
              <mat-icon>format_clear</mat-icon>
            </button>
          </div>
          <div
            #messageInput
            class="message-editor"
            [class.disabled]="isMessageBlocked"
            [attr.contenteditable]="!isMessageBlocked"
            [attr.data-placeholder]="isMessageBlocked ? 'Envio bloqueado para membros' : 'Digite sua mensagem'"
            (keydown)="handleMessageKeydown($event)"
            (input)="onEditorInput()"
            (mouseup)="saveEditorSelection()"
            (keyup)="saveEditorSelection()"
            (focus)="saveEditorSelection()"
            (paste)="onMessagePaste($event)"
          ></div>
          <div class="drag-overlay" *ngIf="draggingMessage">
            Solte o arquivo para anexar
          </div>
          <div class="mention-suggest" *ngIf="showMentionList">
            <button type="button" class="mention-item" (click)="selectMentionAll()">
              <span class="mention-tag">&#64;Todos</span>
              <small>Notificar todos</small>
            </button>
            <button
              type="button"
              class="mention-item"
              *ngFor="let member of filteredMentionMembers"
              (click)="selectMentionMember(member)"
            >
              <span class="mention-tag">&#64;{{ formatUserName(member.name) }}</span>
              <small>{{ member.email }}</small>
            </button>
          </div>
          <div class="input-actions">
            <div class="action-group">
              <button type="button" class="emoji-toggle" (click)="toggleEmojiPicker()" title="Emojis">
                <mat-icon>sentiment_satisfied_alt</mat-icon>
              </button>
              <button
                type="button"
                class="emoji-toggle"
                *ngIf="!isRecording && selectedConversation?.type !== 'AI'"
                (click)="startRecording()"
                title="Gravar áudio"
              >
                <mat-icon>mic</mat-icon>
              </button>
              <button
                type="button"
                class="emoji-toggle danger"
                *ngIf="isRecording && selectedConversation?.type !== 'AI'"
                (click)="stopRecording()"
                title="Parar gravação"
              >
                <mat-icon>stop</mat-icon>
              </button>
              <label class="file-upload" title="Anexar arquivo">
                <input type="file" multiple (change)="handleFileSelected($event)" [disabled]="isMessageBlocked">
                <mat-icon>attach_file</mat-icon>
              </label>
              <button
                type="button"
                class="emoji-toggle"
                (click)="captureScreenAttachment()"
                [disabled]="isMessageBlocked || capturingScreen || sendingAssistantMessage"
                title="Capturar print (Cmd/Ctrl+Shift+D)"
              >
                <mat-icon>{{ capturingScreen ? 'hourglass_top' : 'photo_camera' }}</mat-icon>
              </button>
              <button type="button" class="send" (click)="sendMessage()" title="Enviar" [disabled]="isMessageBlocked || sendingAssistantMessage">
                <mat-icon>{{ sendingAssistantMessage ? 'hourglass_top' : 'send' }}</mat-icon>
              </button>
            </div>
          </div>
          <div class="emoji-picker" *ngIf="showEmojiPicker" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="emoji-btn"
              *ngFor="let emoji of emojiList"
              (click)="addEmojiToMessage(emoji)"
            >
              {{ emoji }}
            </button>
          </div>
        </div>
        <div class="recording-status" *ngIf="isRecording">
          <span class="dot"></span>
          Gravando {{ formatRecordingTime(recordingSeconds) }}
          <button type="button" (click)="cancelRecording()">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</aside>

<div class="image-modal-backdrop" *ngIf="imageModalSrc" (click)="closeImageModal()"></div>
<div class="image-modal" *ngIf="imageModalSrc">
  <button type="button" class="image-modal-close" (click)="closeImageModal()">
    <mat-icon>close</mat-icon>
  </button>
  <img [src]="imageModalSrc" alt="Imagem ampliada">
</div>
